import { createFileRoute, Outlet } from '@tanstack/react-router';

import { AppShell } from 'shared/layouts';

import { GeneralError } from 'features/errors';

export const Route = createFileRoute('/_authenticated/account/_shell')({
  component: AccountLayout,
  errorComponent: GeneralError
});

function AccountLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
